import _ from "lodash";

// reverse enum for lookup by value
export function reverseEnum(obj) {
  let reversed = {};
  _.forEach(_.keys(obj), (key) => {
    reversed[obj[key]] = key;
  })
  return reversed;
}

// raw enum types

export const OperationType = {
  HipReplacement: 0,
  KneeReplacement: 1, // me when successful knee surgery
}

export const SurgerySide = {
  Left: "L",
  Right: "R",
}

export const Sex = {
  Male: "M",
  Female: "F",
}

export const PainScore = {
  Minimal: 0.0,
  Moderate: 2.860295,
  Extreme: 3.227288,
}

export const MobilityScore = {
  MinimalLoss: 0.0,
  ModerateLoss: 1.714200,
  CompleteLoss: 1.827629,
}

export const ADLImpact = {
  NoneToModerate: 0.0,
  UnableToPerform: 0.671918
}

export const RadiologicalSeverity = {
  AsExpected: 0.0,
  RiskOfHarm: 1.772665,
  LikelihoodOfHarm: 3.361679,
}

export const FieldNameMappings = {
  painLevel: "Pain Level",
  radioSeverity: "Radiological Severity",
  adl: "Impact on ADLs",
  mobility: "Mobility",
  surgeonId: "Surgeon ID",
  surgerySide: "Surgery Side",
  ntcSuitability: "NTC Suitability",
  ntcAttendance: "NTC Willingness to Attend",
  roboticSurgery: "Robotic Surgery",
  bedRequired: "HDU/ICU Bed Requirement",
  preassessmentPassed: "Preassessment Passed",
  workOrCareImpairment: "Work or Care Impairment",
  mentalHealthImpairment: "Severe Mental Health Impairment",
  simd: "SIMD Decile",
  operationType: "Operation Type",
  age: "Age",
  sex: "Sex",
  priorityScore: "Priority Score",
  waitingMonths: "Months Waited",
  null: "N/A"
}

export const ValueMappings = {
  surgerySide: reverseEnum(SurgerySide),
  sex: reverseEnum(Sex),
  operationType: {
    0: "Hip Replacement",
    1: "Knee Replacement",
  },
  painLevel: reverseEnum(PainScore),
  mobility: {
    0.0: "Minimal Loss",
    1.714200: "Moderate Loss",
    1.827629: "Complete Loss",
  },
  adl: {
    0.0: "None to Moderate",
    0.671918: "Unable to Perform",
  },
  radioSeverity: {
    0.0: "As Expected",
    1.772665: "Risk of Harm with Delay",
    3.361679: "Likelihood of Harm with Delay",
  },

}